import api from 'api';

export const MENU_CANDIDATE_CATEGORIES_ASYNC_ACTION_START = 'MENU_CANDIDATE_CATEGORIES_ASYNC_ACTION_START';
export const MENU_CANDIDATE_CATEGORIES_ASYNC_ACTION_ERROR = 'MENU_CANDIDATE_CATEGORIES_ASYNC_ACTION_ERROR';
export const MENU_CANDIDATE_CATEGORIES_ASYNC_ACTION_SUCCESS = 'MENU_CANDIDATE_CATEGORIES_ASYNC_ACTION_SUCCESS';
export const MENU_CANDIDATE_CATEGORIES_RESET_STATE = 'MENU_CANDIDATE_CATEGORIES_RESET_STATE';

function menuCandidateCategoriesAsyncActionStart() {
  return {
    type: MENU_CANDIDATE_CATEGORIES_ASYNC_ACTION_START,
  };
}

function menuCandidateCategoriesAsyncActionError(error) {
  return {
    type: MENU_CANDIDATE_CATEGORIES_ASYNC_ACTION_ERROR,
    error,
  };
}

function menuCandidateCategoriesAsyncActionSuccess(data) {
  return {
    type: MENU_CANDIDATE_CATEGORIES_ASYNC_ACTION_SUCCESS,
    data,
  };
}

export function resetMenuCandidateCategoriesState() {
  return {
    type: MENU_CANDIDATE_CATEGORIES_RESET_STATE,
  };
}

export function getMenuCandidateCategoriesAsync() {
  return (dispatch, getState) => {
    dispatch(menuCandidateCategoriesAsyncActionStart());
    return api.request(`usermenuitemcategory/candidates`, 'get')
    .then((data) => {
      dispatch(menuCandidateCategoriesAsyncActionSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(menuCandidateCategoriesAsyncActionError('Unable to get Menu Candidate Categories List'));
      throw (err);
    });
  }
}
